import { z } from 'zod';

/**
 * Backend 429 (rate limit) body from CrossChannelExportRequestsController:
 * - concurrent: { error: 'concurrent_limit_exceeded', limit: number }
 * - window: { error: 'window_limit_exceeded', limit: number, windowHours: number }
 */
export const rateLimitErrorResponse = z.object({
  error: z.enum(['concurrent_limit_exceeded', 'window_limit_exceeded']),
  limit: z.number(),
  windowHours: z.number().optional(),
});

export type RateLimitErrorResponse = z.infer<typeof rateLimitErrorResponse>;

/**
 * Backend 400 (validation) body: { error: string }
 */
export const validationErrorResponse = z.object({
  error: z.string(),
});

export type ValidationErrorResponse = z.infer<typeof validationErrorResponse>;
